<template>
  <div class="container">
    <scroll :pullup="false" :pulldown="false" :scrollX="true" v-if="parkProfile">
          <section class="swiper_box_intro" v-if="imgs.length > 0">
            <div class="swiper">
               <img @click="viewBigPic(parkImages)"
                      class="gallary-img"
                      :src="parkImages"
                  />
                <!-- <swiper :options="options">
                  <swiper-slide v-for="(item,index) in imgs" :key="index">
                    <img
                      class="gallary-img"
                      :src="item"
                    />
                  </swiper-slide>
                  <div v-if="imgs.length > 1" class="swiper-pagination" slot="pagination"></div>
                </swiper> -->
            </div>
          </section>
          <section class="item_box">
              <div class="titleDiv">
                  <img class="title-img" :src="require(`../../assets/images/icon_hi_${common.theme}.png`)" />
                  <span class="title-span"  >{{marketName}}</span>
              </div>

              <div class="titleDiv1">
                  <div class=title_tips></div>
                  <span class="title-span1">项目概况</span>
              </div>

              <div class="bodyDiv1">
                  <span class="body-span-left">招商地址</span>
                  <span class="body-span-right">{{merchantAddress}}</span>
              </div>

                <div class="bodyDiv2">
                  <span class="body-span-left">招商联系人</span>
                  <span class="body-span-right">{{merchantPerson}}</span>
              </div>

              <div class="bodyDiv2">
                  <span class="body-span-left">联系人电话</span>
                  <span class="body-span-right">{{merchantTel}}</span>
              </div>

              <div class="bodyDiv2">
                  <span class="body-span-left">项目状态</span>
                  <span class="body-span-right">{{parkStatusStr}}</span>
              </div>

              <div class="bodyDiv2">
                  <span class="body-span-left">建筑面积</span>
                  <span class="body-span-right">{{coveredArea}}m²</span>
              </div>

              <div class="bodyDiv2">
                  <span class="body-span-left">经营面积</span>
                  <span class="body-span-right">{{floorArea}}m²</span>
              </div>

              <div class="bodyDiv2">
                  <span class="body-span-left">业态构成</span>
                  <span class="body-span-right">{{formats}}</span>
              </div>
           </section>
           <div class="gLine"></div>
          <section class="item_box" v-if="teams.length > 0">
              <div class="titleDiv2">
                  <div class="titleTips_left">
                    <div class=title_tips></div>
                    <span class="title-span1">团队成员</span>
                  </div>
                  <span class="titleTips_right" v-if="teams.length > 8" @click="toParkMemberList()">查看全部</span>

              </div>
               <div class="scroll" ref="gun">
                  <ul  ref="nav" class="shop_list shop_list_scroll">
                    <div ref="personTab"  class="list_item list_item_scroll" v-for="(item,index) in teams" :key="index">
                      <div class="list_item_scroll_con">
                          <img class="list_item-img" :src="item.imageUrl?item.imageUrl:require(`../../assets/images/img_default_face_${common.theme}.jpg`)"/>
                          <span class="list_item-span1">{{item.name}}</span>
                          <span class="list_item-span2">{{item.title}}</span>

                      </div>
                    </div>
                  </ul>
              </div>
          </section>
          <div class="gLine" v-if="teams.length > 0"></div>
           <section class="item_box" v-if="parkContent">
              <div class="titleDiv">
                  <div class=title_tips></div>
                  <span class="title-span1">项目介绍</span>
              </div>
               <div class="bodyDiv3">
                  <div class="body-span-body" v-html="parkContent"></div>
              </div>

           </section>

          <div style="height:116px;"></div>

    </scroll>
    <div class="nodata" v-if="isNodata()">
      <img class="nodataImage" src="../../assets/images/icon_blank.png"/>
      <span>暂无数据</span>
    </div>
    <div class="foot" v-if="parkProfile ">
      <img class="foot_item-img" :src="require(`../../assets/images/img_default_face_${common.theme}.jpg`)"/>
      <div class="foot_phone_div">
          <span class="foot_name_span">{{merchantPerson}}</span>
          <span class="foot_phone_span">{{merchantTel}}</span>

      </div>
      <!-- <div class="foot_button_shu" v-if="lsUrl">电子楼书
      </div>
      <div class="foot_button_NOshu" v-else></div> -->
      <div class="foot_button_phone">
         <img class="foot_button_icon" :src="require(`../../assets/images/icon_phone_${common.theme}.png`)"/>
         <span class="foot_button_phone_span" @click="callPhone()">立即咨询</span>
      </div>
    </div>


    <fade-animation>
      <common-gallary
        :imgs="imgsArr"
        v-show="showGallary"
        @close="handleGallaryClose"
      ></common-gallary>
    </fade-animation>

  </div>
</template>

<script>
import util from "../../utils/util";
import BScroll from 'better-scroll';
import Scroll from "../../components/scroll";
import { mapState } from 'vuex';
import { getParkInfo,getParkMember } from "../../utils/api";
import CommonGallary from '../../components/Gallary'
import FadeAnimation from '../../components/FadeAnimation'
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
// import swiperComponent from '../../components/swiper'

export default {
  name: "projectIntroduction",
  components: {
     Scroll,
     CommonGallary,
     FadeAnimation
  },

  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  filters: {
      teamsType: function(value) {
        if (value == 0) {
          return '招商'
        } else if (value == '1') {
          return '运营'

        } else if (value == '2') {
          return '物业客服'
        } else if (value == '3') {
          return '主管'
        }
      }
    },
  data() {
    return {
      parkProfile:'',
      isFrist:true,
      marketName:'',
      parkImages:'',
      merchantAddress:"",
      merchantPerson:"",
      merchantTel:"",
      parkStatusStr:'',
      parkStatus:'',
      coveredArea:'',
      floorArea:'',
      formats:'',
      parkContent:'',

      enterprise:'',  //原来逻辑有 现在没有
      merchant:'',
      merchantImages:'',
      isView:'',

      lsUrl:'',

      options:{
        pagination: ".swiper-pagination",
          paginationType: "bullets",
          // bulletClass : 'my-bullet',//需设置.my-bullet样式
          // bulletActiveClass: 'my-bullet-active',
          observeParents: true,
          autoplay: 3000,
          speed: 1000,
          loop:true,
          observer: true,
          zoom: {
            maxRatio: 3, //最大倍数
            minRatio: 1, //最小倍数
            toggle: false //不允许双击缩放，只允许手机端触摸缩放。
          }

      },
      teams:[],
      personList:[],
      imgs:[],
      imgsArr:[],
      showGallary:false

    };
  },
  activated () {
    this.getParkInfo();
  },
   methods: {
    isNodata(){
      if(this.isFrist==false){
        if(!this.parkProfile){
          return true;
        }else if(this.parkProfile ==null){
          return true;
        }else if(this.parkProfile ==undefined){
          return true;
        }
      }
      return false;
    },
    handleGallaryClose () {
      this.showGallary = false
    },
    viewBigPic(pic){
      this.imgsArr = [];
      this.imgsArr.push(pic)
      this.showGallary = true;
    },

    getParkMemberAction(id) {
        let params = {
          "marketId": this.common.marketInfo.id,
          "pageNo": "1",
          "pageSize": "100",
          "parkId": id
        }
       getParkMember(params).then(res => { {
          var ret =res.res;
          console.log(ret);
            if (res.res.code == 10000) {
              console.log(res)
              this.teams = res.body.parkMembers;
              setTimeout(() => {
                this.tabScroll();
            }, 1000)
            }
          }
        });
      },

    getParkInfo(){
      let that = this;
       getParkInfo({
        marketId:  this.common.marketInfo.id,
        userId:this.common.userId
      }).then(res => {
        console.log(res);
         this.isFrist =false;
        if (res.res.code === 10000 && res.body) {
          //this.getIndexStyle(res.body);
          let data = res.body;
          if (data.parkProfile) {

              this.parkProfile = data.parkProfile;
              var imgArray =[];
              imgArray.push(this.parkProfile.parkImages)
              this.imgs =imgArray;
              this.parkImages = this.parkProfile.parkImages;
              this.marketName =  this.parkProfile.marketName;
              this.merchantAddress=this.parkProfile.parkAddress;
              this.merchantPerson=this.parkProfile.merchantPerson;
              this.merchantTel=this.parkProfile.merchantTel;
              this.parkStatus=this.parkProfile.parkStatus;
              if(this.parkStatus==0){
                 this.parkStatusStr ='在建中';
              }else if(this.parkStatus==1){
                this.parkStatusStr ='筹备中';
              }else if(this.parkStatus==2){
                this.parkStatusStr ='运营中';
              }else if(this.parkStatus==3){
                this.parkStatusStr ='停业中';
              }
            this.coveredArea=this.parkProfile.coveredArea;
            this.floorArea=this.parkProfile.floorArea;
            this.formats=this.parkProfile.formats;
            this.parkContent=this.parkProfile.parkContent;
            this.lsUrl =this.parkProfile.lsUrl;
            this.getParkMemberAction(this.parkProfile.id);

            //入驻企业
            if (data.enterprise) {
              this.enterprise = data.enterprise;
              // this.content = data.enterprise.content;
            }

            //招商合作
            if (data.merchant) {
              this.merchant = data.merchant;
              this.merchantImages = data.merchant.merchantImages;
              this.isView = data.merchant.isView; //"是否显示图片 (0：显示内容1：显示图片)"
            }
          }
          let address = window.location.href.split('?')[0];
          wx.ready(()=>{
            let obj = {
              title: this.marketName, // 分享标题
              desc: '地址:'+that.merchantAddress,
              link: address+'?marketId='+this.common.marketInfo.id+'&cityId='+that.common.cityId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.parkImages,// 分享图标
              success:function(){
                that.showIframe = false
                util.showToast('已分享')
              }
            }
            wx.onMenuShareAppMessage(obj)
            wx.onMenuShareTimeline(obj)
          })
        }
      });

    },

    tabScroll () {
      if (!this.scroll) {
        //console.log(this.$refs.personTab[0].$el);
        if(this.$refs.nav){
        this.$refs.nav.style.width = 164 * this.$refs.personTab.length/100 + 'rem'
        }
        this.scroll = new BScroll(this.$refs.gun, {
          startX: 0,
          click: true,
          scrollX: true,
            // 忽略竖直方向的滚动
          scrollY: false,
          eventPassthrough: 'vertical'
        });
      } else {
        this.scroll.refresh();
      }
    },


    toParkMemberList() {
      this.$router.push(`/parkMemberList/${this.parkProfile.id}`);
    },

    callPhone () {
      // if (!this.activityDetails.contactNumber) {
      //   util.showToast('该活动不支持电话咨询，敬请谅解');
      // } else {
        window.location.href = 'tel://' + this.merchantTel;
     // }
    },
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
}

.swiper {
  margin-top: 20px;
  height: 462px;
  width: 100%;
}

.my-bullet{
  width:12px;
  height:12px;
  background-color:rgba(0,0,0,0.3);
  border-radius:6px;
}

.my-bullet-active{
  width:12px;
  height:12px;
  background-color:white;
  border-radius:6px;
}

.gallary-img {
  margin-left: 28px;
  height: 462px;
  object-fit: cover;
  width: 694px;
}

.titleDiv{
   width: 100%;
   margin-top: 40px;
   flex-direction: row;
   display: flex;
   justify-content: flex-start;
   align-items: center;
  //  align-items: center;
}

.titleTips_left{
   flex-direction: row;
   display: flex;
   justify-content: flex-start;
   align-items: center;

}

.titleDiv2{
   width: 100%;
   margin-top: 40px;
   flex-direction: row;
   display: flex;
   justify-content: space-between;
   align-items: center;
  //  align-items: center;
}
.titleTips_right{
  margin-right: 28px;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;
}

.title-img{
  margin-left: 28px;
  margin-top: -5px;
  width:44px;
  height:38px;
}

.title-span{
  margin-left: 20px;
  height:56px;
  font-size:40px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:56px;

}
.titleDiv1{
   width: 100%;
   margin-top: 30px;
   flex-direction: row;
   justify-content: flex-start;
   align-items: center;
   display: flex;
  //  align-items: center;
}

.title_tips{
  margin-left: 28px;
  width:6px;
  height:24px;
  background:rgba(23,64,218,1);
}
.title-span1{
  margin-left: 14px;
  height:42px;
  font-size:32px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:42px;
}
.bodyDiv1{
   width: 100%;
   margin-top: 30px;
   flex-direction: row;
   justify-content: flex-start;
  //  align-items: center;
   display: flex;
}
.bodyDiv2{
   width: 100%;
   margin-top: 10px;
   flex-direction: row;
   justify-content: flex-start;
  //  align-items: center;
   display: flex;
}
.body-span-left{
  margin-left: 28px;
  width: 164px;
  display: flex;
  font-size:28px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;
}
.body-span-right{
  width: 530px;
  font-size:28px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:40px;
}
.gLine{
  margin-top: 40px;
  height: 2px;
  width: 100%;
  background-color:rgba(234,234,234,1);
}
.bodyDiv3{
   width: 100%;
   margin-top: 28px;
   flex-direction: row;
   justify-content: flex-start;
  //  align-items: center;
   display: flex;
}
.body-span-body{
  margin-left: 28px;
  width:694px;
//  font-size:28px;
//  font-weight:400;
//  color:rgba(51,51,51,1);
//  line-height:40px;
 margin-bottom: 20px;
 padding-top: 10px;
    /deep/ strong {
        font-weight: bold;
        .fontSize(15px);
        line-height: 50px;
    }
    /deep/ p,
    /deep/ span {
        .fontSize(14px);
        color: rgba(0, 0, 0, 0.9);
        line-height: 40px;
    }
    /deep/ img {
        max-width: 100%;
        min-width: 40%;
        margin: 10px auto;
        height: auto;
        display: block;
    }
    /deep/ figcaption {
        text-align: center;
        .fontSize(14px);
        line-height: 50px;
    }
    /deep/ tr,
    td,
    th {
        .fontSize(14px);
    }
}
//
//
//
//
//
.scroll{
    margin-left: 28px;
    width:694px;
    background:#fff;
}
.shop_list {
  .flex();
   margin-top: 20px;
   width:694px;
  justify-content: space-between;
  .list_item {
    .flex();
    flex-direction: column;
    width: 144px;
    overflow: hidden;
    margin-right: 20px;
    margin-bottom: 20px;
  }

}
.shop_list_scroll{
  flex-wrap: nowrap;
  justify-content: flex-start;
  overflow: auto;
  -webkit-overflow-scrolling : touch;
  .list_item{
    flex-shrink: 0;
     width: 144px;
     display: flex;
     flex-direction: column;
     flex-wrap: wrap;
     overflow: hidden;
     margin-right: 20px;
  }
  .list_item_scroll{
    // margin-right:0;
    // padding-right:20px;
   // background:#f3f4f6;
  }

}

 .list_item_scroll_con{
    width:144px;
    height: 292px;
    //background:blue;
    display: flex;
    // border-radius:16px;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    justify-content: center;
  }

  .list_item-img{
    // margin-top: 40px;
    display: flex;
    width:100px;
    height:100px;
    border-radius:50px;
    background:rgba(232,236,255,1);

  }

  .list_item-span1{
    margin-top: 20px;
    display: flex;
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;

  }

  .list_item-span2{
    margin-top: 8px;
    display: flex;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;

  }
  //
  //
  //
  //
  .foot{
    .flex();
    //justify-content: center;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 116px;
    margin:0 auto;
    background: #fff;
    box-shadow: 0px 0px .18rem 0px rgba(0, 0, 0, 0.05);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:100;
  }
  .foot_item-img{
    margin-left: 28px;
    width:76px;
    height:76px;
    background:rgba(232,236,255,1);
    border-radius: 38px;
  }
  .foot_phone_div
  {
    margin-left: 20px;
    width: 246px;
    display: flex;
    flex-direction: column;
  }
  .foot_name_span{
    height:32px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:32px;
  }
  .foot_phone_span{
    margin-top: 4px;
    height:32px;
    font-size:24px;
    font-family:PingFangSC;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:32px;

  }


  .foot_button_shu{
    width:192px;
    height:68px;
    background:rgba(243,245,253,1);
    border-radius:4px;
    .border(rgba(150,170,240,1));
    font-size:28px;
    font-weight:400;
    color:rgba(23,64,218,1);
    line-height:68px;
    text-align: center;
  }

  .foot_button_NOshu{
    width:192px;
    height:68px;

  }

  .foot_button_phone{
    margin-left: 20px;
    width:332px;
    height:68px;
    background:rgba(23,64,218,1);
    border-radius:4px;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .foot_button_icon{
    width: 32px;
    height: 32px;
  }

  .foot_button_phone_span{
    margin-left: 10px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:40px;

  }


  .nodata{
    width: 100%;
    height: 100vh;;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction:column;
    span{
      font-size:.32rem;
      line-height: .4rem;
      color: #999;
      margin-top:30px;
    }
  }
  .nodataImage{
    width: 200px;
    height: 200px;
  }


</style>
